
export const emailFrequencyIcon = "https://a.suitsupplycdn.com/image/upload/v1632144674/suitsupply/email-preference/email-general.jpg"

export const twicePerWeekIcon = "https://a.suitsupplycdn.com/image/upload/v1632144674/suitsupply/email-preference/email-2w.jpg"

export const oncePerWeekIcon = "https://a.suitsupplycdn.com/image/upload/v1632144674/suitsupply/email-preference/email-1w.jpg"

export const oncePerMonthIcon = "https://a.suitsupplycdn.com/image/upload/v1632144674/suitsupply/email-preference/email-1m.jpg"

export const outOfNewsletterIcon = "https://a.suitsupplycdn.com/image/upload/v1632144674/suitsupply/email-preference/email-no.jpg"
